export const OIDC_LOGIN_SERVICE_TYPE = "oidc-login";
export const OIDC_CREATEACCOUNT_SERVICE_TYPE = "oidc-createaccount";